module.exports = __webpack_public_path__ + "img/bg.1eebc0c2.jpg";